import React, { useState, useEffect, useContext, useRef, Suspense, lazy, useCallback } from "react";
import "./ProjectTasks.css";
import CreatePipeline from "../../tabs/Task/Pipelines/CreatePipeline";
import { useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import _, { result } from "lodash";
import { Col, Row } from "reactstrap";
import ModuleService from "../../common/util/ModuleService";
import Loader from "../../common/loader";
import { Button, message } from "antd";
import AppContext from "../../Context/AppContext";
import { GlobalSearch } from "../GlobalSearch/GlobalSearch";
import CreateTaskModal from "../../tabs/Task/CreateTaskModal"
import ViewPipelines from "../../tabs/Task/Pipelines/ViewPipelines"; 
import AwsServerService from "../../common/util/AwsServerService";
import { RenderAllPipelineTemplates } from "./RenderAllPipelineTemplates";
import { AppDataRequired } from "../../App";
import BottomBar from "./BottomBar";
import { invertColor } from "../HR/TimeClock/Util";
import { useDispatch, useSelector } from "react-redux"; 
import { setAllTaskTimeTracking, setRefershModule } from "../../Context/ReduxContext";
import { canAccess, handleNotificationHyperlink } from "../../common/util/appUtils"; 
import { useNotificationDataRef } from "./ProjectTaskSplit/useCustomHookForFetch";
import TaskRelatedComponents from "./ProjectTaskSplit/TaskRelatedComponents";
import { evaluateEdgeVisibility } from "../../Util/CommonUtil";

const ProjectTasks = (props) => {

  const { allTaskRef, cacheDealsRef } = useNotificationDataRef();
  const AllDeals = useSelector((state) => state.AppReduxContext.AllDeals); // Read state
  const AllAccounts = useSelector((state) => state.AppReduxContext.AllAccounts);
  const RefershModule = useSelector((state) => state.AppReduxContext.refershModule);
  const TaskActiveKey = useSelector((state) => state.AppReduxContext.taskActiveKey);
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const canCreatePipeline = canAccess(accessContext, "Pipeline Template", "Create")
  let module = accessContext.modulePermissions?.find(e=>e.module_name == "Deals");
  const criteria=  module?.selectFilter || [];
  const AppReduxContextDispatch = useDispatch(); // Dispatch actions
  const location = props.location;
  const history = props.history;
  const params = useParams();
  useEffect(() => {
    if (props.getParams) {
      props.getParams(params);
    }
  }, [location]);
  const [dealStatus, setDealStatus] = useState([]);
  const taskDataOfNew = useRef(null); 
  const [groupFilter, setGroupFilter] = useState({
    group1: { name: "Deal Name", value: "Deal_Name", extraKey: "Account_Name", sortOrder: "desc" },
    group2: { name: "Pipeline (Position)", value: "PipelineROWID", sortOrder: "asc" },
  })

  const [isSubTaskView, setIsSubTaskView] = useState(false) 
  const [viewTaskData, setViewTaskData] = useState(null); 
  const [loader, setLoader] = useState(false);
  const DealName = useRef("");
  const [createTaskModal, setCreateTaskModal] = useState(false);
  const [taskModalState, setTaskModalState] = useState({
    module: "TASK", action: "create"
  });
  const [createPiplineModal, setCreatePiplineModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false); 
  const [pipelineTemplates, setPipelineTemplates] = useState([]);
  const [insertBelowData, setInsertBelowData] = useState({});
  const [viewPipelineData, setViewPipelineData] = useState([]);
  const AppData = useContext(AppContext);
  const AppRequireData = useContext(AppDataRequired);
  const { dispatch, state } = AppData || {};
  const [allPipeline, setAllPipeline] = useState([]);
  const [allPipelineVisible, setAllPipelineVisible] = useState([]);
  const [latestActivity, setLatestActivity] = useState([]);
  const [allTaskComments, setAllTaskComments] = useState([]);
  const [searchPipelines, setSearchPipelines] = useState("");
  const [dependencyRefresh, setDependencyRefresh] = useState(false);
  const [zohoServices, setZohoServices] = useState([]);
  const [AllClients, setAllClients] = useState(state.AllAccounts); 
  const [isTaskModalClosed, setIsTaskModalClosed] = useState(null) 
  // const [criteriaFieldGroups, setCriteriaFieldGroups] = useState({});
  const accessedFromAccounts = location?.state?.module == "Accounts" ? true : false;
  const [visibleDeals, setVisibleDeals] = useState(props.fromBody ?accessedFromAccounts ? props.dealObj : props.dealObj?.Deal_Name:AllDeals.slice(0, 10));
  const handleNotificationHyperlinkClick = useCallback((e) => {
  handleNotificationHyperlink(e, history, state.AllAppUsers, state.AllAccounts, cacheDealsRef.current, allTaskRef.current, dispatch, AppReduxContextDispatch );
}, [ history, state.AllAppUsers, state.AllAccounts]);

  const [selectedIdsForTemp, setSelectedIdsForTemp] = useState({ Task: [], Subtask: [] });
  const [allTasksAndSubtasksTemp, setAllTasksAndSubtasksTemp] = useState({ Tasks: [], SubTasks: [] });
  const [dropdownTempTasksDataCache, setDropdownTempTasksDataCache] = useState([]);
  const [selectedTable, setSelectedTable] = useState((history.location.pathname.includes("project/Tasks/defaultView") || props.fromBody)?"tasks":"pipelines");
  const [refreshTasksSubtasks, setRefreshTasksSubtasks] = useState(false);
  const [allPipelineTemplates, setAllPipelineTemplates] = useState([]);
  const [cacheAllPipelineTemplates, setCacheAllPipelineTemplates] = useState([]);
  const [allDependeniesData, setAllDependeniesData] = useState([]);
  const [allTempDependeniesData, setAllTempDependencies] = useState([]);
  const [allBlueprintsData, setAllBlueprintData] = useState([]);
  const [refreshData, setPageRefreshData] = useState(false);

  // Makarand Code For Manage Task View 
  const [isPipelineModalClosed, setIsPipelineModalClosed] = useState(null);

  useEffect(() => {
    if(props.fromBody){
      return;
    }
    setSelectedTable(TaskActiveKey?.tab)
  }, [TaskActiveKey])
  useEffect(() => {
    AwsServerService.getAllTaskFlows().then(res => {
      setAllBlueprintData(res);
    }).catch(err => {
      console.log(err);
    })
    AwsServerService.getPipelineTemplateNames().then(res=>{
        if(res[0].length>0){
          setPipelineTemplates(res[0])
        }
      }).catch((err)=>{
        setPipelineTemplates([])
      });
    // getCriteriaFields()
  }, [])
  useEffect(() => {
    if (history.location.pathname.includes("project/Tasks/defaultView") || props.fromBody) {
      AwsServerService.getAllDependencies().then(r => {
        let data = r.data
        setAllDependeniesData(data)
      }
      )
    } else {
      AwsServerService.getAllTempDependencies().then(r => {
        let data = r.data;
        setAllTempDependencies(data)
      })
    }
  }, [dependencyRefresh, selectedTable])
  useEffect(e => {
    if (state?.AllAccounts) {
      setAllClients(state.AllAccounts)
    }
  }, [state?.AllAccounts])
  useEffect(() => {
    ModuleService.GetModuleList('Requested_Service')
      .then((result) => {
        let services = result?.data;
        setZohoServices(services?.map(element => { return { key: element.id, value: element.id, label: element.Name } }));
      })
  }, [])
  useEffect(e => {
    setSelectedIdsForTemp({ Task: [], Subtask: [] })
    if (createTaskModal) {
      setIsTaskModalClosed(null);
    } else {
      setViewTaskData(null);
      setIsTaskModalClosed(true);
    }
  }, [createTaskModal])
  useEffect(e => {
    if (createPiplineModal) {
      setIsPipelineModalClosed(null);
    } else {
      setIsPipelineModalClosed(true);
    }
  }, [createPiplineModal])

  const [allTasksAndSubtasks, setAllTasksAndSubtasks] = useState({ Tasks: [], SubTasks: [] });
  const [dropdownTasksDataCache, setDropdownTasksDataCache] = useState([]);

  const getTasksAndSubtasks = (data, module) => {
    // console.log("Task <------ 12345 ------>", data)
    let statusColor = "#808080";
    const result = [];
    const taskMap = new Map();
    const subtaskMap = new Map();
    data?.forEach(pipeline => {
      pipeline.Tasks?.forEach(task => {
        if (task.TaskFlowObject) {
          let filterData = task.TaskFlowObject.Nodes?.find(e => e.data.label == task.TaskStatus);
          statusColor = filterData && filterData?.data?.color ? filterData.data.color : "#808080"
        }
        taskMap.set(task.TaskROWID, task);
        result.push({
          label: task.TaskName,
          value: `Tasks_${task.TaskROWID}`,
          status: task.TaskFlowObject?.Nodes?.find(k => k.id == task.TaskStatus)?.data?.label,
          TaskStatus: task.TaskStatus,
          statusColor: statusColor,
          taskData: task
        });
        if (task.SubTasks) {
          task.SubTasks?.forEach(subtask => {
            if (subtask.TaskFlowObject) {
              let filterData = subtask.TaskFlowObject.Nodes.find(e => e.data.label == subtask.TaskStatus);
              statusColor = filterData ? filterData.data.color : statusColor;
            }
            subtaskMap.set(subtask.SubTaskROWID, subtask)
            result.push({
              label: subtask.TaskName,
              value: `SubTasks_${subtask.SubTaskROWID}`,
              status: task.TaskStatus,
              statusColor: statusColor,
              taskData: subtask
            });
          });
        }
      });
    });
    if (module) {
      setAllTasksAndSubtasks({ Tasks: taskMap, SubTasks: subtaskMap })
      // AppReduxContextDispatch(setAllTasks(Array.from(taskMap).map(a=>a[1])))
    } else {
      setAllTasksAndSubtasksTemp({ Tasks: taskMap, SubTasks: subtaskMap })
    } 
    return result;
  };   

  useEffect(() => { 
    if ((selectedTable == 'tasks' || props.fromBody) && refreshTasksSubtasks) {
      AwsServerService.getAllPipeline(props.fromBody? accessedFromAccounts? props.dealObj?.map(rec=>rec.Deal_Name) : props?.dealObj?.Deal_Name:visibleDeals.map(rec=>rec.Deal_Name)).then(res => {
        setRefreshTasksSubtasks(false);
        let data = getTasksAndSubtasks(res, 'tasks');
        setDropdownTasksDataCache(data);
      })
    } else if (refreshTasksSubtasks) {
      AwsServerService.getPipelineTemplatesData().then(res => {
        setRefreshTasksSubtasks(false);
        let data = getTasksAndSubtasks(res);
        setDropdownTempTasksDataCache(data);
      })
    }
  }, [refreshTasksSubtasks])

  useEffect(e => {  
    if(history.location.pathname.includes("project/Tasks/defaultView") || props.fromBody){
      fetchPipelinesOnArrow(); 
    }
  }, [visibleDeals, props.dealObj])
  useEffect(() => {
    if (allPipelineVisible.length > 0) {
      let data = getTasksAndSubtasks(allPipelineVisible, 'tasks');
      setDropdownTasksDataCache(data);
    }
  }, [allPipelineVisible])
  useEffect(() => {
    if (allPipelineTemplates.length > 0) {
      let data = getTasksAndSubtasks(allPipelineTemplates);
      setDropdownTempTasksDataCache(data);
    }
  }, [allPipelineTemplates])
  const fetchTaskTimeTracker = () => {
    AwsServerService.fetchTaskTimeTracker().then(res => {
      if (res) {
        AppReduxContextDispatch(setAllTaskTimeTracking(res))
      }
    })
  }
  
  useEffect(e => { 
    if ((selectedTable == "tasks" && history.location.pathname.includes("project/Tasks/defaultView")) || props.fromBody) { 
        if(DealName.current != "" && DealName.current != undefined){
          fetchOnlyRelevantDealData();
        }else{
          if(props.fromBody){
          }else{
            fetchAllPipelinesInBatches();
          }
        }
        fetchTaskTimeTracker(); 
    } else if (selectedTable == "pipelines" && history.location.pathname.includes("setting/pipeline")) {
      fetchAllPiplineTemplateTasks();
    }
  }, [refreshData, selectedTable])

  useEffect(e => {
    if (RefershModule) {
      if ((RefershModule.module == 'View-Task' && RefershModule.data == 'tasks')) { 
          // if(DealName.current != "" && DealName.current != undefined){
          //   fetchOnlyRelevantDealData();
          // } else{
            // fetchAllPipelinesInBatches();
          // }
          // fetchTaskTimeTracker();
        AppReduxContextDispatch(setRefershModule({ module: "", data: "" }))
      } else if (RefershModule?.module == 'View-Task') {
        fetchAllPiplineTemplateTasks();
        AppReduxContextDispatch(setRefershModule({ module: "", data: "" }))
      } else if (RefershModule.module == 'Refresh_TimeTrackerData') {
        fetchTaskTimeTracker();
      }
    }
  }, [RefershModule]) 
    //   function updateAllTaskComments(allTaskComments, data) { 
    //   const updated = { ...allTaskComments }; 
    //   const groupedNew = data.reduce((acc, item) => {
    //     const type = item.TaskType;  
    //     if (!acc[type]) acc[type] = [];
    //     acc[type].push(item);
    //     return acc;
    //   }, {}); 
    //   Object.keys(updated).forEach(typeKey => {
    //     const newItemsForType = groupedNew[typeKey]; 
    //     if (!newItemsForType) return;
    //     const replaceIds = new Set(newItemsForType.map(n => n.TaskId));
    //     updated[typeKey] = updated[typeKey].filter(old => !replaceIds.has(old.TaskId));
    //     const mappedNew = newItemsForType.map(n => ({
    //       TType: n.TaskType,
    //       TaskId: n.TaskId,
    //       Message: n.Message,
    //       ROWID: n.ROWID
    //     }));
    //     updated[typeKey] = [...updated[typeKey], ...mappedNew];
    //   }); 
    //   return updated;
    // }
  const fetchOnlyRelevantDealData = async () =>{ 
    try { 
    setLoader(true);
    AwsServerService.getAllTaskLatestActivities(DealName.current).then(res=>{
      let activityUpdates = latestActivity.filter(result => result.DealName !== DealName.current);
      setLatestActivity([...activityUpdates, ...res.data]);
    })
    let taskComments;
    AwsServerService.getAllTaskComments(DealName.current).then(res=>{ 
      let comm = allTaskComments.filter(result => result.DealName !== DealName.current);
      taskComments = [...comm, ...res.data];
      setAllTaskComments(taskComments);
    }) 
    // AwsServerService.getAllStatusTimeForTask(DealName.current).then(res=>{
    //   let alltaskStatus = latestActivity.filter(result => result.DealName !== DealName.current);
    //   setAllTaskStatusTime([...alltaskStatus, ...res.data]);
    // }) 
          const res = await AwsServerService.getAllPipeline(DealName.current); 
          const pipelinesWithTaskComments = res.map(pipeline => ({
            ...pipeline,
            Tasks: pipeline.Tasks.map(task => ({
            ...task,
            TaskComments:
            taskComments?.filter(comment => comment.TaskId === task.TaskROWID) || [],
            SubTasks: task?.SubTasks?.map(subTask => ({
              ...subTask,
              TaskComments:
                taskComments?.filter(
                  comment => comment.TaskId === subTask.SubTaskROWID
                ) || []
            })) || []
        }))
      }));
          const updatedPipelinesVisible = allPipelineVisible.filter(result => result.DealName !== DealName.current);
          const updatedPipelinesData = allPipeline.filter(result => result.DealName !== DealName.current);
          const filtered = filterData(criteria, pipelinesWithTaskComments, AllDeals); 
          setAllPipeline([...updatedPipelinesData, ...filtered]); // previously it was pipelinesWithTaskComments in place of filtered
          setAllPipelineVisible([...updatedPipelinesVisible, ...filtered]); //previously it was pipelinesWithTaskComments in place of filtered
        } catch (err) {
          console.error("Error fetching pipelines:", err);
        } finally { 
          DealName.current = "";
          setLoader(false);
        } 
  }
 function filterData(selectedFilterValues, cacheGroup1Data, Alldeals) {
  if (!selectedFilterValues || selectedFilterValues.length === 0) return cacheGroup1Data;

  const isDefault = selectedFilterValues.length === 1 && selectedFilterValues[0].id && !selectedFilterValues[0].initial;
  
  let CacheGroupData = _.cloneDeep(cacheGroup1Data);
  
  if (CacheGroupData && !isDefault) {
    const filteredEntries = Object.entries(CacheGroupData).reduce((acc, [key, pipeline]) => {
      const project = Alldeals.find(deal => deal.Deal_Name === pipeline.DealName);
      
      if (!project) return acc; 
      const filteredTasks = pipeline.Tasks
        .map(task => {
          let filteredSubTasks = [];

          if (Array.isArray(task.SubTasks)) {
            filteredSubTasks = task.SubTasks.filter(subtask =>
              evaluateEdgeVisibility({ Project: project, Task: { ...subtask } }, { Criteria: selectedFilterValues }, subtask));
          }

          const isTaskValid = evaluateEdgeVisibility({ Project: project, Task: { ...task } }, { Criteria: selectedFilterValues }, task);

          if (isTaskValid || filteredSubTasks.length > 0) {
            return { ...task, SubTasks: filteredSubTasks };
          }
          return null;
        })
        .filter(Boolean);  

      if (filteredTasks.length > 0) { 
        acc.push({ ...pipeline, Tasks: filteredTasks });
      }
      return acc;
    }, []); 
    return filteredEntries;   
  } else {
    return cacheGroup1Data;   
  }
}

  const fetchPipelinesOnArrow = async () => { 
    setLoader(true);
    try {
      AwsServerService.getAllTaskLatestActivities(props.fromBody? accessedFromAccounts ? props?.dealObj?.map(rec=>rec.Deal_Name) : props?.dealObj?.Deal_Name:visibleDeals.map(rec=>rec.Deal_Name)).then(res=>{
        setLatestActivity(res.data);
      }).catch(err=>console.log(err))
      let allComments = [];
       AwsServerService.getAllTaskComments(props.fromBody? accessedFromAccounts ? props?.dealObj?.map(rec=>rec.Deal_Name) : props?.dealObj?.Deal_Name:visibleDeals.map(rec=>rec.Deal_Name)).then(res=>{
        allComments = res.data;
        setAllTaskComments(allComments);
       }).catch(err=>console.log(err));
      //  AwsServerService.getAllStatusTimeForTask(props.fromBody?props?.dealObj?.Deal_Name:visibleDeals.map(rec=>rec.Deal_Name)).then(res=>{
      //    setAllTaskStatusTime(res.data);
      //  }).catch(err=>console.log(err))
      const initialRes = await AwsServerService.getAllPipeline(props.fromBody? accessedFromAccounts ? props?.dealObj?.map(rec=>rec.Deal_Name) : props?.dealObj?.Deal_Name:visibleDeals.map(rec=>rec.Deal_Name));
      const pipelinesWithTaskComments = initialRes.map(pipeline => ({
        ...pipeline,
        Tasks: pipeline.Tasks.map(task => ({
          ...task,
          TaskComments:
            allComments?.filter(comment => comment.TaskId === task.TaskROWID) || [],
          SubTasks: task?.SubTasks?.map(subTask => ({
            ...subTask,
            TaskComments:
              allComments?.filter(
                comment => comment.TaskId === subTask.SubTaskROWID
              ) || []
          })) || []
        }))
      }));
       
      const filtered = filterData(criteria, pipelinesWithTaskComments, AllDeals);
      setAllPipelineVisible(filtered); //previously it was pipelinesWithTaskComments
      if(props.fromBody){
        props.setTasksForDeal(filtered);  //previously it was pipelinesWithTaskComments
        setAllPipeline(filtered);         //previously it was pipelinesWithTaskComments
      }
    } catch (err) {
      console.error("Error fetching first 10 pipelines:", err); 
    } finally {
      setLoader(false);
    }
  }; 

   const fetchAllPipelinesInBatches = async () => {
    const batchSize = 20;
    const fullResults = []; 
   for (let start = 0; start < AllDeals.length; start += batchSize) {
     const batch = AllDeals.slice(start, start + batchSize);
     const dealNames = batch.map(deal => deal.Deal_Name || null); 
     try {
       const res = await AwsServerService.getAllPipeline(dealNames);
       fullResults.push(...res);
      } catch (err) {
       console.error("Error fetching pipeline batch:", err);
       break;
      }
    } 
   const filered = filterData(criteria, fullResults, AllDeals);
   setAllPipeline(filered);
  };

  // const fetchAllPiplineTasks = async () => {
  //   setLoader(true);
  //   let addExtra = visibleDealsCount == 0 ? 0 : 1; 
  //   let dealsToRender = AllDeals.slice(0, visibleDealsCount+10);
  //   let dealNames = AllDeals.slice(visibleDealsCount + addExtra, visibleDealsCount + 10).map(deal => deal.Deal_Name || null);
  //   await AwsServerService.getAllPipeline(dealNames).then(res => {
  //     // console.log("------p", res);
  //     setDealsToRender(dealsToRender);
  //     setAllPipeline(prev => [...prev,...res]);
  //     if (taskDataOfNew.current) {
  //       for (let index = 0; index < res?.length; index++) {
  //         for (let index2 = 0; index2 < res[index]?.Tasks?.length; index2++) {
  //           if (res[index]?.Tasks[index2]?.TaskROWID == taskDataOfNew.current?.task?.TaskROWID) {
  //             setLoader(false);
  //             if (taskDataOfNew.current != 'restrict') {
  //               let obj = {
  //                 Pipeline: res[index],
  //                 Task: res[index]?.Tasks[index2]
  //               }
  //               // viewTaskFunction(obj, taskDataOfNew.current.module);
  //             }
  //           }
  //         }
  //       }
  //     }
  //     setLoader(false);
  //   }).catch((err)=>{
  //     setVisibleDealsCount(0);
  //   })
  // }
  const fetchAllPiplineTemplateTasks = async () => {
    setLoader(true);
    await AwsServerService.getPipelineTemplatesData().then(res => {
      setAllPipelineTemplates(res);
      setCacheAllPipelineTemplates(res);
      if (taskDataOfNew.current) {
        for (let index = 0; index < res?.length; index++) {
          if (!_.isEmpty(viewPipelineData)) {
            let pipelineId = viewPipelineData[0]?.PipelineROWID || viewPipelineData[0]?.ROWID
            let pipeline = res[index]?.PipelineROWID == pipelineId;
            if (pipeline) {
              setViewPipelineData([res[index]])
            }
          }
          for (let index2 = 0; index2 < res[index]?.Tasks?.length; index2++) {
            if (res[index]?.Tasks[index2]?.TaskROWID == taskDataOfNew.current?.task?.TaskROWID) {
              setLoader(false);
              if (taskDataOfNew.current != 'restrict') {
                let obj = {
                  Pipeline: res[index],
                  Task: res[index]?.Tasks[index2]
                }
                viewTaskFunction(obj, taskDataOfNew.current.module);
              }
            }
          }
        }
      }
      setLoader(false);
    })
  }
  const getAccountTile = (key) => {
    let accountDeal = AllDeals?.find(d => d?.Deal_Name == key);
    if (accountDeal?.Client?.name) {
      return `${accountDeal.Client.name}`;
    }
  }
  const getColorOfAccountTile = (dealId) => {
    let deal = AllDeals?.find(e => e.Deal_Name == dealId);
    let st = {
      backgroundColor: "#5b6c97",
      color: "white"
    }
    let temp = AllAccounts?.find(ds => ds.id == deal?.Client?.id);
    if (temp?.Color) {
      st["backgroundColor"] = temp?.Color;
      st["color"] = invertColor(temp?.Color, true)
    }
    return st;
  }
  const getColorOfDealStatus = (dealId) => {
    let st = {
      backgroundColor: "#5b6c97",
      color: "white"
    }
    if (groupFilter?.group1?.value == "Deal_Name") {
      let deal = AllDeals?.find(d => d.Deal_Name == dealId);
      if (deal) {
        let temp = dealStatus?.find(ds => ds.display_value == deal.Stage);
        if (temp?.colour_code) {
          st["backgroundColor"] = temp.colour_code;
          st["color"] = invertColor(temp.colour_code, true)
        }
      }
    } else if (groupFilter?.group1?.value == "Stage") {
      let temp = dealStatus?.find(ds => ds.display_value == dealId);
      if (temp?.colour_code) {
        st["backgroundColor"] = temp.colour_code;
        st["color"] = invertColor(temp.colour_code, true)
      }
    } else if (groupFilter?.group1?.value == "Accounts") {
      let temp = state?.AllAccounts?.find(ds => ds.id == dealId);
      if (temp?.Color) {
        st["backgroundColor"] = temp?.Color;
        st["color"] = invertColor(temp?.Color, true)
      }
    }
    return st;
  }
  const getHeaderForDeal = useCallback((key) => {

    return <>
      <span style={getColorOfAccountTile(key)} className='Group1-Card' onClick={() => {
        let data = AllDeals?.find(e => e.Deal_Name == key);
        if (data) {
          history.push({
            pathname: "/d/Accounts/DetailView/" + data?.Client?.id,
            state: {
              data: data,
              action: "DetailView",
              module: "Accounts",
            },
          })
        }
      }}>
        {getAccountTile(key)}
      </span>
      <span style={{ position: "relative", top: "2px", fontWeight: "700" }}>{"/"}</span>
      <span style={getColorOfDealStatus(key)} className='Group1-Card' onClick={() => {
        let data = AllDeals?.find(e => e.Deal_Name == key);
        if (data) {
          history.push({
            pathname: "/d/Deals/DetailView/" + data.id,
            state: {
              data: data,
              action: "DetailView",
              module: "Deals",
            },
          })
        }
      }}>
        {key}
      </span>
    </>
  },[AllDeals, history]);
  
  useEffect(e => {
    if (cacheAllPipelineTemplates) {
      if (searchPipelines) {
        let tempArray = [];
        const seenPipelines = new Set();
        // let temp = cacheAllPipelineTemplates.filter(data => data?.PipelineName?.toLowerCase().includes(searchPipelines?.toLowerCase()))
        for (let el = 0; el < allPipelineTemplates.length; el++) {
          if (allPipelineTemplates[el].PipelineName?.toLowerCase().includes(searchPipelines?.toLowerCase())) {
            if (!seenPipelines.has(allPipelineTemplates[el]?.PipelineROWID)) {
              tempArray.push(allPipelineTemplates[el]);
              seenPipelines.add(allPipelineTemplates[el]?.PipelineROWID)
            }
            continue;
          }
          for (let index = 0; index < allPipelineTemplates[el]?.Tasks?.length; index++) {
            if (allPipelineTemplates[el]?.Tasks[index]?.TaskName?.toLowerCase().includes(searchPipelines?.toLowerCase())) {
              if (!seenPipelines.has(allPipelineTemplates[el]?.PipelineROWID)) {
                tempArray.push(allPipelineTemplates[el]);
                seenPipelines.add(allPipelineTemplates[el]?.PipelineROWID)
              }
            }
          }
        }
        setCacheAllPipelineTemplates(tempArray)
      } else {
        setCacheAllPipelineTemplates(allPipelineTemplates)
      }
    }
  }, [searchPipelines])
  useEffect(e => {
    setDealStatus(AppRequireData.DealStatus);
  }, [AppRequireData.DealStatus])
  
  useEffect(e => {
    setSelectedIdsForTemp({ Task: [], Subtask: [] })
  }, [selectedTable]) 

  useEffect(() => {
    if (params && params?.taskId && !createTaskModal) {
      // const queryParams = new URLSearchParams(location.search);
      // const encodedTaskId = params.get('taskId');
      // const pipelineId = params.pipelineId; 
      const taskId = params.taskId;
      const subTaskId = params.subTaskId;
      if (history.location.pathname.includes("project/Tasks/defaultView")) {
        if (subTaskId) {
          AwsServerService.getSubTaskBySubTaskId(subTaskId).then(res => {
            let data = res[0]?.taskInfo;
            if (data) {
              viewTaskFunction(data, "SUBTASK");
            }
          })
        } else {
          AwsServerService.getTaskById(params.taskId).then(res => {
            let data = res[0]?.taskInfo;
            if (data) {
              viewTaskFunction(data, "TASK");
            }
            // let data=res[0];
            // if(data){ 
            //     viewTaskFunction(data, "TASK",{subtask:undefined}); 
            // }
          })
        }
      } else if (history.location.pathname.includes("setting/pipeline")) {
        if (subTaskId) {
          AwsServerService.getSubTaskBySubTaskIdFromTemplate(subTaskId).then(res => {
            let data = res[0]?.taskInfo || res[0][0]?.taskInfo;
            if (data) {
              viewTaskFunction(data, "SUBTASK");
            }
          })
        } else {
          AwsServerService.getTaskByIdFromTemplate(params.taskId).then(res => {
            let data = res[0]?.taskInfo || res[0][0]?.taskInfo;
            if (data) {
              viewTaskFunction(data, "TASK");
            }
          })
        }
      }
      //  let data = findTaskOrSubTask(selectedTable == "tasks" ? allPipeline : allPipelineTemplates, pipelineId, taskId, subTaskId);
      //  if(data){
      //   viewTaskFunction(data, subTaskId ? "SUBTASK" : "TASK")
      //  }
    }
  }, [params?.taskId]);

  const viewTaskFunction = useCallback((data, module, flag) => {
    if (flag == 'Insert Task') {
      setCreateTaskModal(true);
      setViewTaskData(null);
      setTaskModalState({ module: "TASK", action: "create" })
      setInsertBelowData({ PipelineROWID: data, Position: module, SubTask: false, flag: true })
      return;
    } else if (flag == 'Insert Subtask') {
      setIsSubTaskView(true);
      setCreateTaskModal(true);
      setTaskModalState({ module: "SUBTASK", action: "create" })
      setViewTaskData(null);
      setInsertBelowData({ PipelineROWID: data, Position: module, SubTask: true, flag: true })
      return;
    }
    setTaskModalState({ module: module, action: "edit" })
    setViewTaskData(data)
    setCreateTaskModal(true);

    let pipeline = data.Pipeline;
    let task = data.Task;
    let subtask = data.SubTask;
    let url = '';
    if (task && task?.hasOwnProperty("TaskId") && subtask && subtask?.hasOwnProperty("SubTaskROWID")) {
      setIsSubTaskView(true)
      url = `${task?.TaskId}/${subtask?.SubTaskId}`;
    } else if (task && task?.hasOwnProperty("TaskId")) {
      url = `${task?.TaskId}`;
      setIsSubTaskView(false)
    }
    if(props.fromBody){
      return;
    }
    taskDataOfNew.current = { task: task, module: module }
    const currentPath = history.location.search;
    let newUrl = `${history.location.pathname.includes("project/Tasks/defaultView") ? '/project/Tasks/defaultView' : '/setting/pipeline'}/${url}`;
    if (!currentPath.includes(`taskId`)) {
      history.push(newUrl)
    }
  },[ history ]);
  // Update states when the selected options change 
 const handleSetOpen = useCallback((state) => {
          setCreateTaskModal(state);
          if (!state) {
            setViewTaskData(null);
            taskDataOfNew.current = 'restrict'
            setTaskModalState({
              module: "TASK", action: "create"
            })
          }
        },
  [setCreateTaskModal, setViewTaskData, setTaskModalState]);

  return (
    <div className="project-tasks-wrapper ag-theme-alpine">
      {loader ? <Loader /> : <></>} 
      <CreateTaskModal
        DealName={DealName}
        fromBody = {props.fromBody}
        dealObj = {props.dealObj}
        accessedFromAccounts={accessedFromAccounts}
        setRefreshTasksSubtasks={setRefreshTasksSubtasks}
        getHeaderForDeal={getHeaderForDeal}
        isSubTaskView={isSubTaskView}
        setIsSubTaskView={setIsSubTaskView}
        taskModalState={taskModalState}
        setTaskModalState={setTaskModalState}
        viewTaskData={viewTaskData}
        insertBelowData={insertBelowData}
        open={createTaskModal}
        setOpen={handleSetOpen}
        viewPipelineData={viewPipelineData}
        history={props.history}
        dependencyRefresh={dependencyRefresh}
        setDependencyRefresh={setDependencyRefresh}
        setViewPipelineData={setViewPipelineData}
        viewTaskFunction={viewTaskFunction}
        refreshData={refreshData}
        setPageRefreshData={setPageRefreshData}
        createPiplineModalState={createPiplineModal}
        selectedTable={selectedTable}
        allPipelineData={selectedTable == "tasks" ? allPipeline : allPipelineTemplates}
        allBlueprintsData={allBlueprintsData}
        dropdownTasksDataCache={selectedTable == "tasks" ? dropdownTasksDataCache : dropdownTempTasksDataCache}
        setDropdownTasksDataCache={setDropdownTasksDataCache}
        allTasksAndSubtasks={selectedTable == "tasks" ? allTasksAndSubtasks : allTasksAndSubtasksTemp}
        allAccounts={AllClients}
        allDependeniesData={selectedTable == "tasks" ? allDependeniesData : allTempDependeniesData}
        handleNotificationHyperlink={handleNotificationHyperlinkClick}
        getParams={props.getParams}
        location={location}
        isTaskModalClosed = {isTaskModalClosed}
      />
      <ViewPipelines
        open={createPiplineModal}
        setOpen={(state) => {
          setCreatePiplineModal(state);
        }}
        viewPipelineData={viewPipelineData}
        setViewPipelineData={setViewPipelineData}
        history={props.history}
        allPipelineData={allPipelineTemplates}
        refreshData={refreshData}
        setPageRefreshData={setPageRefreshData}
        viewTaskFunction={viewTaskFunction}
        openTaskModal={createTaskModal}
        selectedTable={selectedTable}
        allBlueprintsData={allBlueprintsData}
        setOpenTaskModal={(state) => {
          setCreateTaskModal(state);
          if (!state) {
            setViewTaskData(null);
            setTaskModalState({
              module: "TASK", action: "create"
            })
          }
        }}
        dropdownTasksDataCache={dropdownTempTasksDataCache}
        allTasksAndSubtasks={allTasksAndSubtasksTemp}
        setDependencyRefresh={setDependencyRefresh}
        allDependeniesData={allTempDependeniesData}
        zohoServices={zohoServices}
        isPipelineModalClosed = {isPipelineModalClosed}
      /> 
      {selectedTable == "tasks" ? 
     <TaskRelatedComponents pipelineTemplates={pipelineTemplates} visibleDeals={visibleDeals} setVisibleDeals={setVisibleDeals} fromBody={props.fromBody} accessedFromAccounts={accessedFromAccounts} dealObj={props.dealObj}
     allDependeniesData={allDependeniesData} allPipeline={allPipeline} allPipelineVisible={allPipelineVisible} allTasksAndSubtasks={allTasksAndSubtasks} 
     allTasksAndSubtasksTemp={allTasksAndSubtasksTemp} checkType={props.checkType} 
    //  clientListStatus={props.clientListStatus} clientListTriggers={props.clientListTriggers}
     createTaskModal={createTaskModal} dealListStatus={props.dealListStatus}
     dealListTriggers={props.dealListTriggers} dealStatus={dealStatus} dependencyRefresh={dependencyRefresh} 
     dropdownTasksDataCache={dropdownTasksDataCache} params={params} dropdownTempTasksDataCache={dropdownTempTasksDataCache}
     groupFilter={groupFilter} location={location} refreshData={refreshData} selectedTable={selectedTable}
     setCheckType={props.setCheckType} setCreateTaskModal={setCreateTaskModal} setDependencyRefresh={setDependencyRefresh} setGroupFilter={setGroupFilter} setLoader={setLoader}
     setInsertBelowData={setInsertBelowData} setPageRefreshData={setPageRefreshData} setViewTaskData={setViewTaskData} viewTaskFunction={viewTaskFunction}
     DealName = {DealName} latestActivity = {latestActivity}
     />: <>
        <Col className="Pipline-Tab-Wrapper" sm={12}>
          <Row className="Header" style={{width: "93%", padding: "8px 12px", borderBottom: "none",
    position: "absolute", top: "-3rem", right: "0"}}>
            <Col sm={10}>
              <GlobalSearch
                text={searchPipelines}
                onSearchFilterTexts={(text) =>
                  setSearchPipelines(text)
                }
              />
            </Col>
            <Col style={{ display: "flex", justifyContent: "end", gap: "10px" }} sm={2}>
              <Button type="primary" style={!canCreatePipeline ? {opacity:0.2} : {}}
              disabled={!canCreatePipeline}
              onClick={() => {
                if(!canCreatePipeline){
                  message.error("Permission Denied");
                  return;
                }
                setIsOpen(true);
              }}>Add Pipeline</Button>
              {
                <CreatePipeline
                  data={{}}
                  mode={"create"}
                  zohoServices={zohoServices}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  open={createPiplineModal}
                  setOpen={(state) => {
                    setCreatePiplineModal(state);
                  }}
                  allPipelineData={allPipelineTemplates}
                  viewPipelineData={viewPipelineData}
                  setViewPipelineData={setViewPipelineData}
                  setPageRefreshData={setPageRefreshData}
                />
              }
            </Col>
          </Row>
          <RenderAllPipelineTemplates
            selectedTable={selectedTable}
            isSubTaskView={isSubTaskView}
            searchPipelines={searchPipelines}
            setIsSubTaskView={setIsSubTaskView}
            setOpen={(state) => {
              setCreatePiplineModal(state);
            }}
            viewTaskFunction={viewTaskFunction}
            // group={groupFilter}
            allPipelineData={cacheAllPipelineTemplates}
            setViewPipelineData={(pipline) => setViewPipelineData([pipline])}
            refreshData={refreshData}
            setPageRefreshData={setPageRefreshData}
            selectedIdsForTemp={selectedIdsForTemp}
            setSelectedIdsForTemp={setSelectedIdsForTemp}
            dropdownTasksDataCache={dropdownTempTasksDataCache}
            allTasksAndSubtasks={allTasksAndSubtasksTemp}
            setDependencyRefresh={setDependencyRefresh}
            allDependeniesData={allTempDependeniesData}
          />
        </Col>
        {(selectedIdsForTemp?.Task?.length > 0 || selectedIdsForTemp?.Subtask?.length > 0) &&
          <BottomBar
            selectedIds={selectedIdsForTemp}
            setSelectedIds={setSelectedIdsForTemp}
            setPageRefreshData={setPageRefreshData}
            refreshData={refreshData}
            selectedTable={selectedTable}
            setIsAdding={() => { }}
            allPipelineData={allPipelineTemplates}
            setSubEditData={() => { }}
            setUpdateFlag={() => { }}
            DealName = {DealName}
            allTasksAndSubtasks={allTasksAndSubtasks}
          />
        }
      </>
      }
    </div>
  );
};

export default React.memo(ProjectTasks);
